function elementToSelectOption(element:string|number) {
  return { id: element, name: element.toString() };
}

function arrayToSelectOption(array: string[]|number[]) {
  return array.map((elem) => elementToSelectOption(elem));
}

export { elementToSelectOption, arrayToSelectOption };
